import { render, staticRenderFns } from "./modalAddEntity.vue?vue&type=template&id=72d9c5ea"
import script from "./modalAddEntity.vue?vue&type=script&lang=js"
export * from "./modalAddEntity.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports